import React from 'react';
import type Page from '@atlassian/jira-board-settings-card/src/ui/card-cover-settings/index.tsx';
import { LazyPage } from '@atlassian/jira-spa/src/view/lazy-page/index.tsx';
import { lazyForPaint } from '@atlassian/react-loosely-lazy';

export const LazyCard = lazyForPaint<typeof Page>(
	() =>
		import(
			/* webpackChunkName: "async-board-settings-card", jiraSpaEntry: "async-board-settings-card" */ '@atlassian/jira-spa-apps-board-settings-card'
		),
);

// eslint-disable-next-line jira/import/no-anonymous-default-export
export default () => (
	<LazyPage Page={LazyCard} pageId="board-settings-card" shouldShowSpinner={false} />
);
